import {create} from 'zustand';
import {immer} from 'zustand/middleware/immer';

interface OverlayState {
  isMaximized: boolean;
  isQueueOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  toggleQueue: () => void;
}

const DEBUG_PLAYER_OVERLAY = false;

export function logPlayerOverlay(event: string, payload?: unknown) {
  if (!DEBUG_PLAYER_OVERLAY || typeof console === 'undefined') {
    return;
  }

  if (typeof payload === 'undefined') {
    console.log(`[PlayerOverlay] ${event}`);
  } else {
    console.log(`[PlayerOverlay] ${event}`, payload);
  }
}

export const usePlayerOverlayStore = create<OverlayState>()(
  immer((set, get) => ({
    isMaximized: false,
    isQueueOpen: false,
    open: () => {
      logPlayerOverlay('store.open');
      set(state => {
        state.isMaximized = true;
        state.isQueueOpen = false;
      });
    },
    close: () => {
      logPlayerOverlay('store.close');
      set(state => {
        state.isMaximized = false;
        state.isQueueOpen = false;
      });
    },
    toggle: () => {
      logPlayerOverlay('store.toggle', {
        nextIsMaximized: !get().isMaximized,
      });
      set(state => {
        state.isMaximized = !state.isMaximized;
        state.isQueueOpen = false;
      });
    },
    toggleQueue: () => {
      logPlayerOverlay('store.toggleQueue', {
        nextIsQueueOpen: !get().isQueueOpen,
      });
      set(state => {
        state.isQueueOpen = !state.isQueueOpen;
      });
    },
  }))
);

export const playerOverlayState = usePlayerOverlayStore.getState();
